import React, {useEffect} from 'react';
import "./Nav.scss"
import {useAnimation, motion} from "framer-motion";
import "./../config"
import Menu from "./Menu";

const Nav = ({goToAbout, goToGallery, goToContacts}) => {
    const controls = useAnimation();
    const controlsHeaderText = useAnimation();

    useEffect(() => {
        controlsHeaderText.start(global.config.animations.headerText.animate);
        window.addEventListener("scroll", () => {
            if (window.scrollY > 300) {
                controls.start(global.config.animations.changeColorNav.color);
                controlsHeaderText.start(global.config.animations.headerText.color_white);
            } else {
                controls.start(global.config.animations.changeColorNav.transparent);
                controlsHeaderText.start(global.config.animations.headerText.color_black);
            }
        });
        return () => {
            //window.removeEventListener("scroll") TODO check from project
        }
    }, []);

    return (
        <motion.div className={`nav`} animate={controls} variants={global.config.animations.changeColorNav} >
			<div className="nav__container--logo">
				<motion.img className="nav__logo"
					 src={require('./../assets/images/logo.png')}/>
				<motion.h1 className="nav__title" variants={global.config.animations.headerText} initial={"initial"} animate={controlsHeaderText}>Studio<b>Signorello</b></motion.h1>
			</div>

            <Menu goToAbout={goToAbout} goToGallery={goToGallery} goToContacts={goToContacts}/>

            {/*<img className="nav__menu"
                 src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/1004px-Google_%22G%22_Logo.svg.png"
                 alt={"logo"}/>*/}
        </motion.div>
    );
}

export default Nav;
